var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { CleatTriageContext } from './CleatTriageContext';
var ctInteractionTemplate = {
    interaction_modality: { code: 'phonecall' },
    direction: 'inbound',
    minutes_spent: 0,
    interacted_with: 'member'
};
var CleatTriageProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), triageNotes = _b[0], setTriageNotes = _b[1];
    var value = useMemo(function () { return ({
        ctInteraction: __assign(__assign({}, ctInteractionTemplate), { notes: triageNotes.replace(/\r\n/g, '<br />') }),
        setTriageNotes: setTriageNotes
    }); }, [triageNotes]);
    return (_jsx(CleatTriageContext.Provider, { value: value, children: children }));
};
export default CleatTriageProvider;
